/**
 * Helpers for creating FolderThirdParties instance
 */

import type { IBaseNotary } from "../../BaseNotaryFactory";
import type { IThirdParty, IAddThirdPartyRequest, IThirdPartyAutocompleteResult, IThirdPartyAutocompleteOptions } from "../FolderThirdParties";
import {
	createAddThirdPartyMethod,
	createGetThirdPartiesMethod,
	createGetThirdPartyMethod,
	createUpdateThirdPartyMethod,
	createRemoveThirdPartyMethod,
	createResendCodeMethod,
	createAutocompleteMethod,
} from "./folderThirdPartiesMethodsHelpers";

export interface FolderThirdPartiesInstance {
	addThirdParty(folderUid: string, data: IAddThirdPartyRequest): Promise<IThirdParty>;
	getThirdParties(folderUid: string): Promise<IThirdParty[]>;
	getThirdParty(uid: string): Promise<IThirdParty>;
	updateThirdParty(
		uid: string,
		data: { phone?: string | null; role_description?: string | null; company_name?: string | null },
	): Promise<IThirdParty>;
	removeThirdParty(uid: string): Promise<void>;
	resendCode(uid: string): Promise<{ message: string; emailQueued?: boolean; code?: string }>;
	autocomplete(searchTerm: string, options?: IThirdPartyAutocompleteOptions): Promise<IThirdPartyAutocompleteResult[]>;
}

/**
 * Create FolderThirdParties instance with all methods
 */
export function createFolderThirdPartiesInstance(baseNotary: IBaseNotary): FolderThirdPartiesInstance {
	return {
		addThirdParty: createAddThirdPartyMethod(baseNotary),
		getThirdParties: createGetThirdPartiesMethod(baseNotary),
		getThirdParty: createGetThirdPartyMethod(baseNotary),
		updateThirdParty: createUpdateThirdPartyMethod(baseNotary),
		removeThirdParty: createRemoveThirdPartyMethod(baseNotary),
		resendCode: createResendCodeMethod(baseNotary),
		autocomplete: createAutocompleteMethod(baseNotary),
	};
}
